// @flow

import { stringify } from 'query-string';
import {
  jobUrl,
  jobApplicationUrl,
  reportJobAdUrl,
  sendJobUrl
} from 'src/config';
import checksum from 'src/modules/request-checksum';
import {
  createAuthenticatedHttpClient,
  createUnauthenticatedHttpClient,
  withRequestId,
  localiseUrl
} from 'src/modules/seek-api-request';

function createJobApplicationUri(id) {
  return `${jobApplicationUrl}/${id}`;
}

const jobDetailsApi = createUnauthenticatedHttpClient();

function fetch(
  id: number | string | null,
  isDesktop: boolean,
  locale: Locale,
  requestId: ?string
): ChaliceJob {
  return jobDetailsApi
    .send({
      label: 'job-details',
      timeout: 3000, // Avg 1100ms, so use minimum of 3000
      // $FlowFixMe: this is probably a real bug that needs to be tidied up
      url: localiseUrl(locale, `${jobUrl}/${id}`),
      headers: withRequestId(requestId),
      params: { isDesktop, locale }
    })
    .then(({ data }) => data);
}

function jobApplication(id: string): ChaliceJobApplication {
  const uri = createJobApplicationUri(id);

  return createAuthenticatedHttpClient()
    .send({
      timeout: 3000, // Avg 1700ms, so use minimum of 3000
      url: uri,
      label: 'job-application'
    })
    .then(response => response.data)
    .catch(error => {
      if (error.status === 404) {
        return null;
      }

      throw error;
    });
}

type SendFraudReportInput = {
  email: string,
  comment: string,
  jobId: number,
  reason: string
};

const sendFraudReport = (data: SendFraudReportInput) =>
  createUnauthenticatedHttpClient()
    .send({
      label: 'report-job',
      timeout: 8000, // Avg 4400ms, so use maximum of 8000
      method: 'post',
      url: reportJobAdUrl,
      data: stringify(data),
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      }
    })
    .then(response => response.data);

type SendJobInput = {
  jobId: number,
  receiverName: string,
  receiverEmail: string,
  senderName: string,
  senderEmail: string
};

const sendJobToFriend = (data: SendJobInput, locale: Locale) => {
  const { jobId, ...formValues } = data;
  return createUnauthenticatedHttpClient()
    .send({
      label: 'send-job',
      timeout: 8000,
      method: 'post',
      url: localiseUrl(locale, `${sendJobUrl}/${jobId}`),
      data: stringify(formValues),
      headers: {
        'Content-type': 'application/x-www-form-urlencoded',
        'x-seek-checksum': checksum(formValues)
      }
    })
    .then(response => response.data);
};

export default {
  fetch,
  jobApplication,
  sendFraudReport,
  sendJobToFriend
};
